export const PHONE_REGEX = /^\+7\d{10}$/;
export const EMPTY_NAME_MESSAGE = 'Введите имя';
export const EMPTY_PHONE_MESSAGE = 'Введите телефон';
export const TAG_RESPONSE_TIME = 'Ответим за 15 минут';
export const TAG_EXPERIENCE = 'Опыт 10+ лет';

export const DEFAULT_PHOTOS: string[] = [
  'managers/manager-1.png',
  'managers/manager-2.png',
  'managers/manager-3.png',
  'managers/manager-4.png',
  'managers/manager-5.png',
  'managers/manager-6.png',
  'travelata/logo/logo-blue-t.svg',
];
